import React from "react";
import { PageHeader } from "../../components/ui";
import DistributorKeys from "../../components/DistributorKeys";
import { useDistributorData } from "./DistributorData";

export default function MyKeysPage() {
  const { distributorId } = useDistributorData();
  return (
    <>
      <PageHeader
        title="My keys"
        subtitle="Every key your company has issued. Click a key to update the customer details."
      />
      <DistributorKeys distributorId={distributorId} exportName="my-keys" />
    </>
  );
}
